import { FormattedRate } from "./formatRate";

export const sortRateByDate = (prev: FormattedRate, next: FormattedRate) => {
  return Number(next.activeFrom) - Number(prev.activeFrom);
};
